import {
    dataSource
} from "@/api/api";
import {setToken, getToken} from '@/assets/js/token.js'
export default {
    name: 'dynamicInfo',
    components: { //注册组件

    },
    data() {
        return {
            newsTitle: '新闻资讯',
            baseForm: {},
            baseForm1:{//政策动态参数
                isHot: "1",
                orders: [
                    {
                        asc: true,
                        column: ""
                    }
                ],
                pageNum: 1,
                pageSize: 10,
                searchCount: true,
                type: ""
            },
            hotNews: [],
            isFujian:false,
            isFujianPDF:false,
        }
    },
    computed: {},
    filters: {},
    methods: {
        postIndexNewsFn() { 
            dataSource.postIndexNews(this.baseForm1)
                .then(res => {
                    if (res.data.success) {
                        let data = res.data.data;
                        data.list.map(item => {
                            this.hotNews.push(item)
                        })
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
                .catch(err => {});
        },
        postIndexNewsDetailFn() {
            dataSource.postIndexNewsDetail({
                    id: sessionStorage.getItem('dynamicId')
                })
                .then(res => {
                    if (res.data.success) {
                        let data = res.data.data;
                        data.publicationTime = data.publicationTime.substring(0, 10)
                        this.baseForm = data;
                        if(this.baseForm.uploadFile){
                            this.isFujian = true;
                        }else{
                            this.isFujian = false;
                        }
                        if(this.baseForm.attachmentUrl){
                            this.isFujianPDF = true;
                        }else{
                            this.isFujianPDF = false;
                        }
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
                .catch(err => {});
        },
        getTabName() {
            this.newsTitle = sessionStorage.getItem('dynamicName');
        },
        goInfo(item) { //热点详情
           sessionStorage.setItem('dynamicId', item.id)
           sessionStorage.setItem('dynamicName',item.newsType)
           this.postIndexNewsDetailFn();
		},
        //立即申请
        apply(){
            if (!getToken()) {
                this.$message.error('请先登录，登录后可进行后续操作！')
                this.showPop();
            } else {
                this.$router.push({
                    name: 'applyDiscount'
                })
            }
        },
        // 显示登录框
        showPop() {
            this.$router.push({
                name: 'login'
            })
        },
    },
    created() {},
    mounted() {
        this.postIndexNewsFn();
        this.postIndexNewsDetailFn();
        if (this.$route.params.tabActiveName != undefined && this.$route.params.tabActiveName != "") {
            this.getTabName();
        }

    },
    activated() {}
}
